var map = {
	"./01-b&r-logo.png": "2830",
	"./02-pku-logo.png": "5ec5",
	"./03-thu-logo.png": "a916",
	"./04-xjtu-wneu-polimi-logo.png": "4e13",
	"./05-yi-logo.png": "88c7",
	"./06-washu-logo.png": "8443",
	"./07-cnbm-win-logo.png": "8657",
	"./08-sues-xd-logo.png": "2034",
	"./09-shunya-logo.png": "bc2d",
	"./10-montreal-logo.png": "9a32",
	"./11-jia-logo.png": "64eb",
	"./13-tubseu-logo.png": "8e7e",
	"./14-xauat-logo.png": "1026",
	"./15-sjtuiuc-logo.png": "3302",
	"./16-bjtu-logo.png": "2210",
	"./17-sie-logo.png": "87fb",
	"./18-tju-tuda-logo.png": "f8c4",
	"./19-solar-offspring-logo.png": "668d",
	"./20-scut-polito-logo.png": "f9b0",
	"./21-unnc-alpha-logo.png": "b122",
	"./22-israel-logo.png": "a977"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5b7";